export const ITEM_UPLOAD_URL = '/items/new'
export const EDIT_ITEM_URL = (id: number, origin?: string) =>
  `/items/${id}/edit${origin ? `?origin=${origin}` : ''}`
export const TERMS_URL = '/terms_and_conditions'
export const MY_ORDERS_SOLD_URL = '/my_orders?order_type=sold'
export const SELLING_HELP_URL = '/help/52'
